module.exports = __webpack_public_path__ + "static/media/teachers-04.novo.c8ddd6f2.png";